var map = {
	"./de-DE/btn_vote-text.png": "4d5e",
	"./en-GB/btn_vote-text.png": "0606",
	"./en-US/btn_vote-text.png": "819f",
	"./es-ES/btn_vote-text.png": "4477",
	"./es-MX/btn_vote-text.png": "53a1",
	"./fr-CA/btn_vote-text.png": "7335",
	"./fr-FR/btn_vote-text.png": "339c",
	"./it-IT/btn_vote-text.png": "91b2",
	"./ja-JP/btn_vote-text.png": "5a45",
	"./pt-BR/btn_vote-text.png": "fbfa",
	"./zh-TW/btn_vote-text.png": "466d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af63";